const config = require("./config.json")["production"];

module.exports = config;
